import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { isSameDay, isSameMonth } from 'date-fns';
import { Subject } from 'rxjs';
import { BpgEventsService } from '../../bpg-events.service';
import { CalendarEvent, CalendarView, CalendarDateFormatter} from 'angular-calendar';
import { BpgCommonService } from '../../../bpg-common/services/bpg-common.service';
import { Router } from '@angular/router';
import { DataService } from "../../../bpg-common/services/data.services";
import { DatePipe } from '@angular/common';
import { ConstantValues } from '../../../bpg-common/models/bpg-constants';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

const RED_CELL: 'red-cell' = 'red-cell' as const;
const colors: any = {
  backgroundColor: {
    primary: '	#b62027',
  }
};

@Component({
  selector: 'app-events-calendar',
  templateUrl: './events-calendar.component.html',
  styleUrls: ['./events-calendar.component.css'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }
  ]

})

export class EventsCalendarComponent implements OnInit {

  landingData: any;
  selectedMonthYear: any;
  siteData: any;
  siteList: any;
  selectedBpgsData: any;
  userAndRoleIdDTO: any;
  loginData1: any;
  loginData = JSON.parse(localStorage.getItem('loginData'));
  bpgList: any;
  selectedSiteId: any  = Number(localStorage.getItem('userSiteId'));
  eventList = [];
  eventDetail = [];
  selectedBpgId: any;
  prevMonth: any;
  nxtMonth: any;
  prevYear: any;
  nxtYear: any;
  date: any;
  virtualFlag : boolean;
  searchKey: any;
  eventDate: any;
  selectedSite: any;
  dateForGetNextMonth: any;
  dateForGetPrevMonth: any;
  siteAndPath: any;
  selectedBpg: any;
  iconKeyList: any;
  deviceInfo = null;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  previousButton: any;
  buttonType: any;
  isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
  selectAllConstant = "Select All";
  @ViewChild('modalContent', { static: false })
  modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  showNextDate: Date = new Date();

  showPrevDate: Date = new Date();

  previousMonth: Date = new Date();

  nextMonth: Date = new Date();

  cssClass: string = RED_CELL;

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [];

  activeDayIsOpen = false;
  adminId: string;
  isNaacAdmin: boolean;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  fromDate : any;
  toDate : any;
  currentMonth: any;
  siteNamePrint:any;
  bpgNamePrint:any;
  sarchedEventCalendarItems:any;
  timeOutError: boolean;
  /**
  * @class EventsListViewComponent
  * @constructor
  */
  constructor(private readonly  bpgEventsService: BpgEventsService, private readonly bpgCommonService: BpgCommonService, private readonly  router: Router, private readonly  data: DataService, private readonly datePipe: DatePipe,
    private readonly spinner: Ng4LoadingSpinnerService, 
    private readonly environment: EnvironmentConfiguration) { }


  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;

      if (
	(isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
	events.length === 0
      ) {
	this.activeDayIsOpen = false;
      } else {
	this.activeDayIsOpen = true;
      }
    }
    this.date = this.viewDate;

  }

  handleEvent(_action: string, event: CalendarEvent): void {
    this.getEventCompleteDetails(event.id);
    event.cssClass = 'red-cell';
  }

  getEventCompleteDetails(id) {

    for (const e of this.eventList) {
      if (e.eventId === id) {
	this.eventDetail = e;
      }
    }
    this.viewEventDetails(this.eventDetail);

  }

  setPreviousMonth() {
    this.date = this.viewDate;
    this.prevYear = this.previousMonth.getFullYear();
    this.nxtYear = this.previousMonth.getFullYear() + 1;

    this.showPrevDate = this.previousMonth;
    this.showNextDate = this.nextMonth;
    this.prevMonth = this.prevMonth - 1;
    this.nxtMonth = this.nxtMonth - 1;
    //previous goes nagative
    if (this.prevMonth < 0) {
      this.prevMonth = 11;
      this.prevYear = this.prevYear - 1;
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }
    //Next goes nagative
    if (this.nxtMonth < 0) {
      this.nxtMonth = 11;
      this.nxtYear = this.nxtYear - 1;
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    //previous goes beyond
    if (this.prevMonth > 11) {
      this.prevMonth = 0;
      this.prevYear = this.nxtYear + 1;
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }
    //next goes beyond
    if (this.nxtMonth > 11) {
      this.nxtMonth = 0;
      this.nxtYear = this.nxtYear + 1;
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
    this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
    // updates from date and to date
    this.currentMonth.setMonth(this.currentMonth.getMonth() - 1);
    this.updateDates(this.date);
    // load calendar data accordingly
    this.searchEvents();
  }

  setNextMonth() {
    this.date = this.viewDate;
    this.prevYear = this.previousMonth.getFullYear();
    this.nxtYear = this.previousMonth.getFullYear();
    this.showPrevDate = this.previousMonth;
    this.showNextDate = this.nextMonth;
    this.prevMonth = this.prevMonth + 1;
    this.nxtMonth = this.nxtMonth + 1;
    //previous goes nagative
    if (this.prevMonth < 0) {
      this.prevMonth = 11;
      this.prevYear = this.prevYear - 1;
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }
    //Next goes nagative
    if (this.nxtMonth < 0) {
      this.nxtMonth = 11;
      this.nxtYear = this.nxtYear - 1;
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    //previous goes beyond
    if (this.prevMonth > 11) {
      this.prevMonth = 0;
      this.prevYear = this.nxtYear + 1;
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }
    //next goes beyond
    if (this.nxtMonth > 11) {
      this.nxtMonth = 0;
      this.nxtYear = this.nxtYear + 1;
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
    this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
    // update from date and to date
    this.currentMonth.setMonth(this.currentMonth.getMonth() + 1);
    this.updateDates(this.date);
    // load calendar data accordingly
    this.searchEvents();
  }

  setCalendarMonth() {
    this.prevYear = this.previousMonth.getFullYear();
    this.nxtYear = this.previousMonth.getFullYear();

    this.showPrevDate = this.viewDate;
    this.showNextDate = this.viewDate;
    this.nxtMonth = this.showNextDate.getMonth() + 1;
    this.prevMonth = this.showPrevDate.getMonth() - 1;
    //previous goes nagative
    if (this.prevMonth < 0) {
      this.prevMonth = 11;
      this.prevYear = this.prevYear - 1;
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }
    //Next goes nagative
    if (this.nxtMonth < 0) {
      this.nxtMonth = 11;
      this.nxtYear = this.nxtYear - 1;
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    //previous goes beyond
    if (this.prevMonth > 11) {
      this.prevMonth = 0;
      this.prevYear = this.nxtYear + 1;
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }
    //next goes beyond
    if (this.nxtMonth > 11) {
      this.nxtMonth = 0;
      this.nxtYear = this.nxtYear + 1;
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
    this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
  }

  setCalendarMonthForDate(date) {
    this.prevYear = date.getFullYear();
    this.nxtYear = date.getFullYear();

    this.nxtMonth = date.getMonth() + 1;
    this.prevMonth = date.getMonth() - 1;

    if (this.prevMonth < 0) {
      this.prevMonth = 11;
      this.prevYear = this.prevYear - 1;
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }
    else {
      this.previousMonth = new Date(this.previousMonth.setFullYear(this.prevYear));
    }

    //next goes beyond
    if (this.nxtMonth > 11) {
      this.nxtMonth = 0;
      this.nxtYear = this.nxtYear + 1;
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    else {
      this.nextMonth = new Date(this.nextMonth.setFullYear(this.nxtYear));
    }
    this.previousMonth = new Date(this.previousMonth.setMonth(this.prevMonth));
    this.nextMonth = new Date(this.nextMonth.setMonth(this.nxtMonth));
    // update from date and to date
    this.updateDates(date);
  }

  eventsPresent(data) {
    this.adminId = localStorage.getItem('adminId');
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin')==='true'){
      this.isbpgLeadAdmin = true;
    }
    if(localStorage.getItem('isNaacAdmin') === 'true')
    {
      this.isNaacAdmin = true
    }
    this.events = [];
    
   
    for (const data1 of data) {
      
      let date = data1.eventCreateDate;
      date = date.substring(0, 10).split('-');
      let virtualflag: any;
    if (data1.virtualFlag === true)
    {
      virtualflag = " | [VIRTUAL]";
    }
    else{
      virtualflag = " ";
    }
    if (data1.eventLevelFlag === false && (this.adminId === '1' || this.adminId === '2' || this.adminId === '3'|| this.adminId === '4'  || this.isbpgAdmin || this.isbpgLeadAdmin || this.isNaacAdmin))
    {
      virtualflag = " | [NAAC]";
    }
      date = `${date[1]}/${date[2]}/${date[0]}`;
      this.events.push(
	{
	  id: data1.eventId,
	  start: new Date(date),
	  end: new Date(date),
	  title:  `${data1.siteName.split("(")[0]} - ${data1.bpgName.split("(")[0]}  |  ${data1.eventName} ${virtualflag}`,
    color: colors.backgroundColor,
	  cssClass: 'red',
    allDay: true,
    
	}
      )
    }
  }

  ngOnInit() {
    this.currentMonth = new Date();
    this.updateDates();
    if (this.isIEOrEdge) {
      this.deviceInfo = 'IE';
    } else {
      this.deviceInfo = 'Chrome';
    }
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

	this.router.navigate(['/log-out']);
      }
    }

    this.spinner.show();
    sessionStorage.removeItem("MembershipData");

    this.data.siteIdAndPath.subscribe(siteIdAndPath => this.siteAndPath = siteIdAndPath);
   if(this.siteAndPath.path === 'naacHome'){
      this.selectedSiteId= this.siteAndPath.siteId;
      this.selectedBpgId = this.siteAndPath.naacAffinityId;
    }
    if (this.siteAndPath.path === 'eventViewDetails') {
      this.date = new Date(this.siteAndPath.eventCreateDate + 'T00:00:00');
      this.selectedSiteId = (this.siteAndPath.siteId) ? this.siteAndPath.siteId : 0;
      this.selectedBpgId = (this.siteAndPath.bpgId) ? this.siteAndPath.bpgId : null;
      this.selectedBpg = this.siteAndPath.bpgName;
      this.selectedSite = this.siteAndPath.siteName;

      if (this.selectedBpgId === null || this.selectedBpg === this.selectAllConstant) {
	this.selectedBpg = this.selectAllConstant;
      }
      else {
	this.selectedBpg = '--Select BPG--';
      }

      if (this.selectedSiteId === 0 || this.selectedSite === this.selectAllConstant) {
	this.selectedSite = this.selectAllConstant;
      }
      else {
	this.selectedSite = '--Select Site--';
      }

      this.searchKey = (this.siteAndPath.searchKey) ? this.siteAndPath.searchKey : '';
      this.onDateChange(this.date);
      this.siteAndPath.path = null;
    }

    else if (this.eventDate != null && this.eventDate !== 'null') {
      this.date = new Date(this.eventDate);
      this.viewDate = this.date;
      this.setCalendarMonthForDate(this.date);
    }
    else if (this.siteAndPath !== 'default message') {
      if (this.siteAndPath.eventCreateDate != null) {
	if (this.deviceInfo === 'IE') {
	  this.date = this.datePipe.transform(this.siteAndPath.eventCreateDate, 'yyyy-MM-dd');
	  this.date = new Date(this.date);
	} else {
	  this.date = new Date(this.siteAndPath.eventCreateDate);
	}
	this.siteAndPath.eventCreateDate = null;
      } else {
	this.date = new Date();
      }
      this.onDateChange(this.date);
    }
    else {
      this.date = new Date();
    }

    this.loginData1 = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';

    this.getSiteDetailsOnLoad();
   
    // setTimeout(function () {
    //   this.spinner.hide();
    // }.bind(this), 500);

  }
  getSiteDetailsOnLoad(){
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
      this.siteList.unshift({ siteId: 0, siteName: this.selectAllConstant });

      if (this.siteList != null) {
        // for defualt site change siteId
        if (this.selectedSiteId !== 1) {
          const selectedSite = this.siteList.find(s => s.siteId === this.selectedSiteId);
          if (selectedSite) {
              this.selectedSite = selectedSite.siteName;
          } else {
              // Handle case where selectedSiteId is not found
              this.selectedSiteId = this.siteList[1].siteId;
              this.selectedSite = this.siteList[1].siteName;
          }
      } else {
          this.selectedSiteId = this.siteList[1].siteId;
          this.selectedSite = this.siteList[1].siteName;
      }
      }      
      this.getBPGDetailsOnLoad();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
   });
  }
  getBPGDetailsOnLoad(){
    this.selectedBpgsData =
    {
      "filter": {
	"siteId": this.selectedSiteId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
      if (this.bpgList != null) {
        const selectedBpg = this.bpgList.find(b1 => b1.bpgId === this.selectedBpgId);
        if (selectedBpg) {
            this.selectedBpg = selectedBpg.bpgName;
        }
      }
      this.afterAllDetailsLoad();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

  }
  afterAllDetailsLoad(){
    this.data.eventDate.subscribe(eventDate => this.eventDate = eventDate);
    this.setCalendarMonth();

    this.loginData1 = (localStorage.getItem('loginData')) ? JSON.parse(localStorage.getItem('loginData')) : '';

    const fromDate = this.datePipe.transform(this.fromDate, ConstantValues.dateFormats.dateFormat);
    const toDate = this.datePipe.transform(this.toDate, ConstantValues.dateFormats.dateFormat);
    this.landingData =
    {
      "filter": {
      "siteId": this.selectedSiteId,
      "fromDate": fromDate,
      "toDate": toDate
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 1000,
      "sortDirection": "ASC",
      "sortProperty": null,
      "uid": ""
    }
    localStorage.setItem('eventsCalendarItems', JSON.stringify(this.landingData));
    this.previousButton = sessionStorage.getItem(this.buttonType);
    this.sarchedEventCalendarItems = this.landingData;
    if (JSON.parse(localStorage.getItem('searchedEventsCaledarItems')) !== undefined) {
      if (this.previousButton === 'BACK') {
    this.landingData = JSON.parse(localStorage.getItem('searchedEventsCaledarItems'));
    localStorage.removeItem('searchedEventsCaledarItems');
    sessionStorage.removeItem(this.buttonType);
      }
    }
    else {
      this.landingData = JSON.parse(localStorage.getItem('eventsCalendarItems'));
    }

    sessionStorage.removeItem(this.buttonType);
    this.getAllEvents();
  }
  updateDates(selectedDate?:Date) {
    const year = selectedDate ? selectedDate.getFullYear() :this.currentMonth.getFullYear();
    const month = selectedDate ? selectedDate.getMonth() :this.currentMonth.getMonth();
    // Set from date to the first day of the current month
    this.fromDate = new Date(year, month, 1);
    // Set to date to the last day of the current month
    this.toDate = new Date(year, month + 1, 0);
  }
  /** For getting all events
  * @class EventsListViewComponent
  * @method getAllEvents
  * @returns Promise
  */
  getAllEvents() {
    this.spinner.show();
    this.landingData.filter.userId = this.loginData.userId;
    this.bpgEventsService.getAllEvents(this.landingData).subscribe(data => {

      if (data != null) {
	  this.eventList = data.content;
	  this.eventsPresent(this.eventList);
    // newly added for printing site and bpg name in pdf
      if(this.selectedSiteId==null || this.selectedSiteId==undefined || this.selectedSiteId==0){
        this.siteNamePrint = "Select All";
      }else if(typeof(this.selectedSiteId)=='number'){
        if(this.siteList!=null && this.siteList!=undefined){
          this.siteNamePrint  = this.siteList.find(b => b.siteId === this.selectedSiteId).siteName;
        }
      }else{
        this.siteNamePrint = "Select All";
      }
      if(this.selectedBpgId==null || this.selectedBpgId==undefined
        || this.selectedBpgId==0){
          this.bpgNamePrint = "Select All";
      }else if(typeof(this.selectedBpgId)=='number'){
        if(this.bpgList!=null && this.bpgList!=undefined){
          this.bpgNamePrint  = this.bpgList.find(b => b.bpgId === this.selectedBpgId).bpgName;
        }
      }else{
        this.bpgNamePrint = "Select All";
      }
      }
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }
  /** For datepicker date change
   * @class EventsListViewComponent
   * @method onChange
   */
  onDateChange(event) {
    this.viewDate = event;
    this.setCalendarMonthForDate(event);

    this.selectedMonthYear = event;

    this.landingData =
    {
      "filter": {
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 1000,
      "sortDirection": "ASC",
      "sortProperty": null,
      "uid": ""
    }
    // this.spinner.show();
    // this.getAllEvents();
  }
  /** For site change from site list
   * @class EventsListViewComponent
   * @method siteChange
   * @returns Promise
   */
  siteChange(event) {
    this.selectedBpgId = null;
    this.selectedBpg = null;
    this.selectedSiteId = event.siteId;
    this.selectedBpgsData =
    {
      "filter": {
	"siteId": this.selectedSiteId,

      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });


    });

  }

  /** For bpg change from bpg list
   * @class EventsListViewComponent
   * @method bpgChange
   * @returns Promise
   */

  bpgChange(event) {
    this.selectedBpgId = null;
    this.selectedBpgId = event.bpgId;
  }

  /** For open Event view deatils component
    * @class EventsListViewComponent
    * @method viewEventDetails
    */
  viewEventDetails(events) {
    this.selectedBpgId = (this.selectedBpgId) ? this.selectedBpgId : null;
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    sessionStorage.setItem(this.iconKeyList, "LIST");
    Object.assign(events, { 'componentName': 'eventsCalendarView' });
    Object.assign(events, { 'selectedSiteId': this.selectedSiteId });
    Object.assign(events, { 'selectedBpgId': this.selectedBpgId });
    if (this.selectedBpg !== null &&  this.selectedBpg !== undefined) {
      Object.assign(events, { 'selectedBpgName': this.selectedBpg.bpgName });
    }
    if (this.selectedSite !== undefined) {
      Object.assign(events, { 'selectedSiteName': this.selectedSite.siteName });
    }
    Object.assign(events, { 'searchKey': this.searchKey });
    sessionStorage.setItem("eventDetails", JSON.stringify(events));
    localStorage.setItem('searchedEventsCaledarItems', JSON.stringify(this.sarchedEventCalendarItems));
    this.router.navigate(['event-view-details']);
  }

  /** For button search
    * @class EventsListViewComponent
    * @method searchEvents
    */
  searchEvents() {
    const fromDate = this.datePipe.transform(this.fromDate, ConstantValues.dateFormats.dateFormat);
    const toDate = this.datePipe.transform(this.toDate, ConstantValues.dateFormats.dateFormat);
    this.selectedSiteId = (this.selectedSiteId) ? this.selectedSiteId : null;
    this.selectedBpgId = (this.selectedBpgId) ? this.selectedBpgId : null;
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    if (this.selectedBpgId === 0) {
      this.selectedBpgId = null;
    }

    this.landingData =
    {
      "filter": {
      "siteId": this.selectedSiteId,
      "bpgId": this.selectedBpgId,
      "fromDate": fromDate,
      "toDate": toDate
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": this.searchKey,
      "size": 2000,
      "sortDirection": "ASC",
      "sortProperty": null,
      "uid": ""
    }
    this.sarchedEventCalendarItems = this.landingData;
    this.getAllEvents();

  }

  /** For adding 365 days to current day
    * @class BpgSiteHomePageComponent
    * @method addDays
    * @params Date, number
    */

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  downloadEvents(){
    const filteredData = this.eventList.map(({ siteName, bpgName, eventName,
      eventCreateDate,startTime,endTime,description}) => ({ SiteName:siteName, BpgName:bpgName, EventName:eventName,
       EventDate:eventCreateDate,StartTime:startTime,EndTime:endTime,Description:description}));
    this.bpgEventsService.exportAsExcelFile(filteredData, "EventsReport");
  }

  printEvents(){
    const printContents = document.getElementById("printEvents").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    this.spinner.hide()
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  }
}
